import { useState } from "react";
import { FiEdit } from "react-icons/fi";
import UpdateSource from "./UpdateSource";

export default function SourceWidget({ vehicle, vehicleId }: any) {
  const [updateModal, setUpdateModal] = useState<boolean>(false);
  return (
    <div className="">
      <div className="flex justify-between items-center border-b border-t bg-gray-100 px-2 py-3">
        <div className="">Vehicle Source URL</div>
        <button onClick={() => setUpdateModal(true)} className="">
          <FiEdit />
        </button>
      </div>

      <div className="">
        <div className="flex justify-between p-2 text-xs">
          <a
            href={vehicle?.source_url}
            target="_blank"
            className=" text-blue-500 "
          >
            {vehicle?.source_url || "-"}
          </a>
        </div>
      </div>
      <UpdateSource
        isVisible={updateModal}
        setVisible={setUpdateModal}
        vehicle={vehicle || {}}
        vehicleId={vehicleId}
      />
    </div>
  );
}
